import { render } from "./mazda.vue?vue&type=template&id=a0633e9c"
import script from "./mazda.vue?vue&type=script&lang=js"
export * from "./mazda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__